import { render, staticRenderFns } from "./shopAuthList.vue?vue&type=template&id=1c2ec92e&scoped=true&"
import script from "./shopAuthList.vue?vue&type=script&lang=js&"
export * from "./shopAuthList.vue?vue&type=script&lang=js&"
import style0 from "./shopAuthList.vue?vue&type=style&index=0&id=1c2ec92e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2ec92e",
  null
  
)

export default component.exports